import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './new-process.component.scss';
var NewProcess = /** @class */ (function (_super) {
    tslib_1.__extends(NewProcess, _super);
    function NewProcess(element) {
        return _super.call(this, element) || this;
    }
    NewProcess.prototype.init = function () {
    };
    NewProcess.prototype.bindEvents = function () {
    };
    return NewProcess;
}(Base));
export { NewProcess };



//////////////////
// WEBPACK FOOTER
// ./components/new-process/new-process.component.ts
// module id = 573
// module chunks = 0